import { IVehicle } from '@/models/Vehicle';
import { konsole } from '@/services/Konsole';
import { AxiosResponse } from 'axios';
import axios from 'axios';

const headerlist = {
  'X-Forwarded-Host':
    window.location.hostname +
    (window.location.port !== '' &&
    window.location.port !== '80' &&
    window.location.port !== '443'
      ? ':' + window.location.port
      : '')
};

/**
 * Vehicle Service
 *
 * Vehicle Service handles rest calls from axios to get vehicles or certain vehicles
 */
class VehicleService {
  constructor() {
    // konsole.init('new instance of VehicleService');
  }

  public async checkApiAvailability(): Promise<boolean> {
    const check = await axios.get<any>(
      'https://pew.autoflex.dev/'
      // 'http://localhost:4000/'
    );
    return check.data.name;
  }

  public async getVehicles(params?: any): Promise<AxiosResponse> {
    return axios.get<IVehicle[]>(`https://pew.autoflex.dev/api/vehicles/`, {
      params,
      headers: headerlist
    });
    // `http://localhost:4000/api/vehicles/`, {params, headers: headerlist});
  }

  public async getVehicle(vehicleId: string): Promise<AxiosResponse> {
    return axios.get<IVehicle>(
      `https://pew.autoflex.dev/api/vehicles/` + vehicleId,
      { headers: headerlist }
    );
    // `http://localhost:4000/api/vehicles/` + vehicleId, {headers: headerlist});
  }
}

export const vehicleService = new VehicleService();
